var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBagNotActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.747 15.48C12.3017 15.48 11.9217 15.3217 11.607 15.005C11.2923 14.6883 11.135 14.3073 11.135 13.862C11.135 13.4167 11.2933 13.0367 11.61 12.722C11.9267 12.4073 12.308 12.25 12.754 12.25C13.2 12.25 13.58 12.4087 13.894 12.726C14.208 13.0433 14.3653 13.4243 14.366 13.869C14.3667 14.3137 14.208 14.6937 13.89 15.009C13.572 15.3243 13.191 15.4817 12.747 15.481M8.85007 7.19194C9.0184 7.53362 9.36622 7.75 9.74711 7.75H15.7528C16.1337 7.75 16.4816 7.53356 16.6499 7.1918L17.65 5.161C17.7913 4.89233 17.7853 4.63167 17.632 4.379C17.4787 4.12633 17.2487 4 16.942 4H8.558C8.25133 4 8.02133 4.12633 7.868 4.379C7.71467 4.63167 7.70867 4.89267 7.85 5.162L8.85007 7.19194ZM9.381 20H16.119C17.4057 20 18.499 19.5497 19.399 18.649C20.2997 17.7483 20.75 16.653 20.75 15.363C20.75 14.8243 20.6577 14.2997 20.473 13.789C20.2883 13.2783 20.0217 12.8133 19.673 12.394L16.9308 9.10915C16.7408 8.88156 16.4596 8.75 16.1632 8.75H9.33685C9.04037 8.75 8.75918 8.88156 8.56918 9.10915L5.827 12.394C5.47833 12.8133 5.21167 13.2783 5.027 13.789C4.84233 14.299 4.75 14.8237 4.75 15.363C4.75 16.653 5.20033 17.7483 6.101 18.649C7.00167 19.5497 8.095 20 9.381 20Z",
    fill: "white",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBagNotActive);
export default __webpack_public_path__ + "static/media/icon_bag_notActive.e88d3bce90c6f2ec0e77ef22b4306d7c.svg";
export { ForwardRef as ReactComponent };